import React from 'react';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router-dom';

import { Filter } from './Filter';
import { Header } from './Header';
import { TableList } from './TableList';
import { useGetListResolution886Report } from '@/hooks/v2/resolution-886';
import { useResolution886ReportFilter } from '@/context/Resolution886ReportFilter';
import type { FormFields } from './types';

export function Content(): JSX.Element {
	const history = useHistory();
	const { parameters, offset, limit, handleSetParameters } = useResolution886ReportFilter();

	const { isFetching, isLoading, data } = useGetListResolution886Report({
		...parameters,
		limit,
		offset
	});

	function handleOnSubmit(data: FormFields): void {
		handleSetParameters(data);
	}

	function handleOnCancel(): void {
		history.push({
			pathname: '/custom-reports/resolution-886',
			search: '?cleared=true'
		});
	}

	return (
		<Row>
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>
				<Filter loading={isFetching} onSubmit={handleOnSubmit} onCancel={handleOnCancel} />
			</Col>
			<Col span={24}>
				<TableList
					loading={isLoading}
					data={data?.rows}
					total={data?.total}
					limit={data?.limit}
					offset={data?.offset}
				/>
			</Col>
		</Row>
	);
}
